export const exerciseOptions = {
  headers: {
    "X-RapidAPI-Key": process.env.REACT_APP_RAPID_API_KEY,
    "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
  },
};



// const options = {

//   headers: {
//     'X-RapidAPI-Key': '2a2bd31c69mshcff6f3044bcbae8p124e95jsndffac68be949',
//     'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
//   }
// };



export const youtubeOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "39d4db584bmshe48255d07f645e9p114acajsnf4c6801119af",
    "X-RapidAPI-Host": "youtube-search-and-download.p.rapidapi.com",
  },
};

export const fetchData = async (url, options) => {
  const response = await fetch(url, options);
  const data = await response.json();

  return data;
};
